'use client';

import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const SkipToMainContent = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <a
      id={'skip-to-main-content'}
      href={'#main-content'}
      className={
        'sr-only focus:not-sr-only focus:absolute focus:z-50 focus:bg-white focus:p-l focus:text-black focus:no-underline'
      }
    >
      {t('a11y.skipToMainContent')}
    </a>
  );
};
